import React, { useState } from 'react'
import ModalEliminarUnPaquete from './ModalEliminarUnPaquete'
import ModalVerLosSuministrosEnUnPaquete from './ModalVerLosSuministrosEnUnPaquete'
import ModalActivarPaquete from './ModalActivarPaquete'

const TablaAgregarPaquetesQuirurgicos = ({item, passActualizarTablaPaquetes}) => {
  const [modalOnSuministrosEnUnPaquete, setmodalOnSuministrosEnUnPaquete]=useState(false)
  const [modalOnEliminarPaquete, setmodalOnEliminarPaquete]=useState(false)
  const [modalOnActivarPaquete, setmodalOnActivarPaquete]=useState(false)
  

    const passActualizarPa=(data)=>{
      passActualizarTablaPaquetes(data)
    }

    const handleOnclickSuministrosEnUnPaquete=()=>{
      setmodalOnSuministrosEnUnPaquete(true)
    }

    const hancleClickEliminar=()=>{
      setmodalOnEliminarPaquete(true)
    }

    const hancloClickActivar=()=>{
      setmodalOnActivarPaquete(true)
    }

    
  return (
    <>
      <tr className="border-b">
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          {
            item.PQEdoDes === 'C'?
            <button
              type="button"
              onClick={hancloClickActivar}
              className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
            >
               Activar
            </button>
            :
            <button
                type="button"
                onClick={handleOnclickSuministrosEnUnPaquete}
                className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
              >
                Ver Suministros 
              </button>
              
              
          }
          
          </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          {item.PQEdoDes !== 'P'?
          null:
        <button
              type="button"
              onClick={hancleClickEliminar}
              className="inline-block px-3 py-1.5 bg-red-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
            >
              Eliminar 
            </button>
            }
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.PaqCod}</td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
          {item.PaqDes}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.PQCantPaq}</td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.PQEdoDes === 'P'? 'Pendiente':(item.PQEdoDes === 'R'? 'Despachado Parcial':(item.PQEdoDes === 'C'? 'Cancelado':(item.PQEdoDes === 'D'? 'Despachado':(item.PQEdoDes === 'V'? 'Devuelto':null))))}</td>
      </tr>
      {modalOnSuministrosEnUnPaquete? <ModalVerLosSuministrosEnUnPaquete setmodalOnSuministrosEnUnPaquete={setmodalOnSuministrosEnUnPaquete} item={item}/>:null}
      {modalOnEliminarPaquete? <ModalEliminarUnPaquete setmodalOnEliminarPaquete={setmodalOnEliminarPaquete} item={item} passActualizarPa={passActualizarPa}/>:null}
      {modalOnActivarPaquete? <ModalActivarPaquete setmodalOnActivarPaquete={setmodalOnActivarPaquete} item={item} passActualizarPa={passActualizarPa}/>:null}
    </>
  )
}

export default TablaAgregarPaquetesQuirurgicos